import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function useProfessorClasses(month, year) {
    const params = month && year ? `?month=${month}&year=${year}` : '';
    return useQuery({
        queryKey: ['professor-classes', month ?? 'current', year ?? 'current'],
        queryFn: () => apiClient(`/attendance/my-classes${params}`),
        staleTime: 1000 * 60 * 2,
    });
}
export function useClassAttendance(classId) {
    return useQuery({
        queryKey: ['class-attendance', classId],
        queryFn: () => apiClient(`/attendance/class/${classId ?? ''}`),
        enabled: !!classId,
        staleTime: 1000 * 60,
        // El formulario siembra su estado UNA vez: siempre desde el servidor, nunca
        // desde la caché (una caché pre-guardado re-sembrada y re-enviada revertía
        // la lista recién guardada y borraba notas). Ver isFetchedAfterMount en el form.
        refetchOnMount: 'always',
    });
}
export function useMarkAttendance(classId) {
    const queryClient = useQueryClient();
    return useMutation({
        // Backend: POST /attendance/class/:classId/bulk
        mutationFn: (payload) => apiClient(`/attendance/class/${classId}/bulk`, {
            method: 'POST',
            body: JSON.stringify(payload),
        }),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ['professor-classes'] });
            void queryClient.invalidateQueries({ queryKey: ['class-attendance', classId] });
        },
    });
}
//# sourceMappingURL=useProfessorClasses.js.map